import { SidemenuContext } from "@/contexts/Sidemenu";
import { Drawer, type DrawerProps } from "@mui/material";
import { useContext } from "react";

export function SidemenuContainer({ children }: DrawerProps) {
	const { isOpen } = useContext(SidemenuContext);

	return (
		<Drawer
			variant='persistent'
			anchor='left'
			open={isOpen}
			sx={{
				display: "flex",
				height: "100%",
				width: isOpen ? 320 : 0,
				transition: "width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
				flexShrink: 0,
				position: "relative",
				"& .MuiDrawer-paper": {
					paddingInline: 1,
					paddingTop: 1,
					paddingBottom: 14.5,
					width: 320,
					display: "flex",
					flexDirection: "column",
					gap: 1,
					boxSizing: "border-box",
					position: "relative",
					height: "calc(100vh)",
					overflow: "hidden",
				},
			}}
		>
			{children}
		</Drawer>
	);
}
